module.exports = __webpack_public_path__ + "img/ck-mutil-star5-bg-side.e81634c1.png";